import { render } from "./ProjectHeader.vue?vue&type=template&id=b67ed650"
import script from "./ProjectHeader.vue?vue&type=script&lang=js"
export * from "./ProjectHeader.vue?vue&type=script&lang=js"

import "./ProjectHeader.vue?vue&type=style&index=0&id=b67ed650&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__